import React, { useEffect, useRef, useState } from 'react'
import HardArea from './HardAreas/HardArea'
import LandingPage from './LandingPage/LandingPage'
import styles from './Home.module.css'
import { sanityClient, urlFor } from '../../lib/sanity.client'
import { ProjectTypes } from '../../lib/types/projectTypes'
import { useLocation } from 'react-router-dom'
import { useTranslation } from '../../TranslationProvider'

export type HomeProps = {
    setIsFooterVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    setTheme: React.Dispatch<React.SetStateAction<string>>;
}

const Home = (props: HomeProps) => {

    const { currLang } = useTranslation(); // ✅ use context here
    const [projectsTypes, setProjectsTypes] = useState<ProjectTypes[]>([]);
    const location = useLocation(); // Detects route changes
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        props.setIsFooterVisible(false);
        window.scrollTo(0, 0)
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
        }, 50); // Adjust if needed

        return () => clearTimeout(timeout);
    }, [location]);

    useEffect(() => {
        (sanityClient as any).fetch(`*[_type == "typeProject" && showType == "Visible"]  | order(order asc) {
            ...
        }`)
        .then((data : ProjectTypes[]) => {
            setProjectsTypes(data)
        })
        .catch(console.error)
    }, []);

    return (
        <div ref={scrollRef} className={styles.home_scroll}>
            <LandingPage />
            {projectsTypes.map((item, index) => (
                <div className={styles.section} key={index}>
                    <HardArea setSearch={props.setSearch} img={urlFor(item.image).url()} title={item.type[currLang]} theme={item.theme} setTheme={props.setTheme} />
                </div>
            ))}
        </div>
    )
}

export default Home

